<template>
    <rkm-modal
        ref="modal"
        title="Observação"
    >
        <rkm-form
            ref="Form"
        >
            <rkm-form-textarea
                :validations="validations.observacao"
                label="Observação"
                v-model="model.observacao"
            />
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                @click="saveObservacao"
                color="primary"
                type="submit"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>
<script>

// Mixin.
import { repository } from '@/mixins'

export default {
     computed: {
        validations() {
            return {
                observacao: {
                    max: 1000,
                }
            }
        }
    },
    data: () => ({
        model: {
            id: null,
            observacao: null,
        },
    }),
    methods: {

        open(index) {

            this.model.id = index
            this.model.observacao = this.data[index].observacao
            this.$refs.modal.show()
        },
        saveObservacao() {

            this.$emit('saveObservacao', this.model)
            this.$refs.modal.hide()

        },
    },
    mixins: [ repository ],
    props: {
        data: { type: [Array, Object], required: true },
    },
}
</script>